import { _getInstance, StatsigClient } from '@statsig/js-client'
import Config from 'Common/Config/Config'
// eslint-disable-next-line no-unused-vars
import { IFeatureFlagsService } from './types'

/**
 * @implements {IFeatureFlagsService}
 */
export class StatsigFeatureFlagsService {
  #client

  constructor () {
    const existingInstance = _getInstance(
      process.env.FEATURE_FLAGS__STATSIG_CLIENT_KEY
    )

    if (existingInstance instanceof StatsigClient) {
      this.#client = existingInstance
      return
    }

    this.#client = new StatsigClient(
      process.env.FEATURE_FLAGS__STATSIG_CLIENT_KEY,
      {},
      {
        environment: {
          tier: Config.getEnvironment()
        }
      }
    )
  }

  getExperiment (experiment) {
    return this.#client.getExperiment(experiment).value
  }

  reset () {
    const existingUserId = this.#client.getContextHandle().user.userID

    if (!existingUserId) {
      if (this.#client.loadingStatus === 'Ready') {
        return Promise.resolve()
      }

      return this.#client.initializeAsync().then(() => {})
    }

    return this.#client.updateUserAsync({ userID: undefined }).then(() => {})
  }

  setProfile (puuid) {
    const existingUserId = this.#client.getContextHandle().user.userID

    if (existingUserId === puuid) {
      if (this.#client.loadingStatus === 'Ready') {
        return Promise.resolve()
      }

      return this.#client.initializeAsync().then(() => {})
    }

    return this.#client
      .updateUserAsync({
        userID: puuid
      })
      .then(() => {})
  }
}
